/**
 * Smooth Scroll when click on link
 */
import Jump from 'jump.js'

const links = document.querySelectorAll('.js-smooth-scroll');
links.forEach((el) => {

  const url = el.getAttribute('href');
  const hash = url.substring(url.indexOf('#') + 1);

  el.addEventListener('click', (ev) => {
    ev.preventDefault();
    Jump(`#${hash}`, {
      duration: 1000
    })
  })

});
